import React from "react";

const Ball = ({ number, animate = false }) => {
  const className = animate ? "ball ball_animate" : "ball";
  function _getColorByNumber() {
    const color = {
      1: { common: "", additional: "" },
      2: { common: "#FF0000", additional: "#CA0000" },
      3: { common: "#D39900", additional: "#C38D00" },
      4: { common: "#04D300", additional: "#01A626" },
      5: { common: "#01A626", additional: "#236C2F" },
      6: { common: "#01DEEC", additional: "#007C8D" },
      7: { common: "#0143EC", additional: "#222D88" },
      8: { common: "#C05FEE", additional: "#78169B" },
      9: { common: "#EB00FF", additional: "#B80084" },
      0: { common: "#FFD600", additional: "#C69500" },
    };

    return color[number % 10];
  }
  return (
    <div className={className}>
      <svg
        width="82"
        height="82"
        viewBox="0 0 82 82"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="40.553"
          cy="40.553"
          r="40.553"
          fill={`url(#paint_linear_${number})`}
        />
        <path
          d="M75.3857 61.3313C79.0184 55.2545 81.106 48.1476 81.106 40.553C81.106 34.967 79.9766 29.6448 77.9337 24.8022C58.1291 17.2825 29.5303 16.663 3.90189 23.1744C1.40548 28.43 0.00618766 34.3077 -1.52588e-05 40.5116V40.5944C0.00762184 48.2327 2.12702 55.3766 5.80579 61.4736C27.7573 58.878 48.0564 57.5517 75.3857 61.3313Z"
          fill={`url(#paint_radial_${number})`}
        />
        <circle cx="40.449" cy="38.9933" r="19.4447" fill="#DBCCB0" />
        <text
          x={number <= 9 ? "32" : "25"}
          y="48"
          fill="#000000"
          fontSize="25"
          fontWeight="normal"
        >
          {number}
        </text>
        <defs>
          <linearGradient
            id={`paint_linear_${number}`}
            x1="40.553"
            y1="0"
            x2="40.553"
            y2="81.1061"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CECBC2" />
            <stop offset="1" stopColor="#B0AB9A" />
          </linearGradient>
          <radialGradient
            id={`paint_radial_${number}`}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(40.553 40.0833) rotate(90) scale(19.3945 46.1189)"
          >
            <stop stopColor={_getColorByNumber()?.common} />
            <stop offset="1" stopColor={_getColorByNumber()?.additional} />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
};
export default Ball;
